import alertClasses from "@mui/material/Alert/alertClasses";
import buttonBaseClasses from "@mui/material/ButtonBase/buttonBaseClasses";
import buttonClasses from "@mui/material/Button/buttonClasses";
import svgIconClasses from "@mui/material/SvgIcon/svgIconClasses";
import alertTitleClasses from "@mui/material/AlertTitle/alertTitleClasses";
import { button } from "../../styles/utils/button.module";
import { typographyResponsive } from "../../styles/utils/typography.module";
import { resolve } from "../../styles/utils/utils";
export const standardStyles = (dt, severity) => {
    const bgColor = resolve(dt.color, severity);
    return Object.assign(Object.assign({}, outlinedStyles(dt, severity)), { [`.${alertClasses.action} .${buttonBaseClasses.root}`]: {
            borderWidth: 0,
        }, [`.${alertClasses.action} .${buttonClasses.text}`]: {
            color: dt.cta.outlined.color.text.primary.default,
        }, [`.${alertClasses.message},`]: {
            color: resolve(dt.color.onSignal, severity).container,
        }, [`.${buttonBaseClasses.root} .PixelIcon`]: {
            backgroundColor: resolve(dt.color.onSignal, severity).container,
        }, backgroundColor: bgColor.container });
};
export const filledStyles = (dt, severity) => {
    const bgColor = resolve(dt.color, severity);
    return {
        backgroundColor: bgColor.key,
        [`.${svgIconClasses.root}`]: {
            // to be removed
            fill: `${dt.color.surface.key} !important`,
        },
        ".PixelIcon": {
            backgroundColor: dt.color.surface.key,
        },
        [`.${alertClasses.message}`]: {
            color: resolve(dt.color.onSignal, [severity[1]]).key,
        },
        [`.${alertClasses.action} .${buttonClasses.text}`]: {
            color: dt.cta.outlined.color.text.inverted.default,
        },
    };
};
export const outlinedStyles = (dt, severity) => {
    const color = resolve(dt.color, severity);
    return {
        borderColor: color.key,
        [`.${svgIconClasses.root}`]: {
            // to be removed
            fill: `${resolve(dt.cta.outlined.color.text, severity).default} !important`,
        },
        ".PixelIcon": {
            backgroundColor: resolve(dt.cta.outlined.color.text, severity).default,
        },
        [`.${alertClasses.message}`]: {
            color: color.key,
        },
        [`.${alertClasses.action} .${buttonBaseClasses.root}`]: button(dt.cta.outlined, severity, dt),
    };
};
export const MuiAlertTheme = (dt) => {
    const alertTitle = typographyResponsive(dt, "body1.bold", {
        marginTop: 0,
        marginBottom: dt.stacked.xSmall,
    });
    const alertMessage = typographyResponsive(dt, "body1.regular", {
        marginBottom: 0,
    });
    const correction = "3px";
    return {
        defaultProps: {},
        styleOverrides: {
            root: {
                borderRadius: dt.brand.borderRadius.small,
                borderWidth: dt.brand.borderWidth.xSmall,
                padding: `${dt.inset.squish.medium.vertical} ${dt.inset.squish.medium.horizontal}`,
                [`.${alertClasses.action}`]: {
                    marginRight: 0,
                    paddingTop: 0,
                    [`.${buttonBaseClasses.root}`]: {
                        marginBottom: 0,
                    },
                },
                [`.${alertClasses.message}`]: Object.assign(Object.assign({}, alertMessage), { maxWidth: "640px", paddingTop: `calc(${dt.inset.squish.small.vertical} + ${correction})`, paddingBottom: `calc(${dt.inset.squish.small.vertical} + ${correction})` }),
                [`.${alertClasses.message} + .${alertClasses.action}`]: {
                    paddingLeft: dt.inline.large,
                },
                [`.${alertClasses.icon}`]: {
                    opacity: 1,
                    paddingTop: `calc(${dt.inset.squish.small.vertical} + ${correction})`,
                    paddingBottom: `calc(${dt.inset.squish.small.vertical} + ${correction})`,
                    marginRight: dt.inline.small,
                    ".PixelIcon": {
                        width: dt.icon.size.medium,
                        height: dt.icon.size.medium,
                    },
                },
                [`.${alertClasses.root}`]: alertTitle,
                [`.${alertTitleClasses.root}`]: {
                    marginBottom: dt.stacked.xSmall,
                },
            },
            standard: {
                borderWidth: dt.brand.borderWidth.xSmall,
                borderStyle: "solid",
            },
            standardSuccess: standardStyles(dt, ["signal", "success"]),
            standardInfo: standardStyles(dt, ["signal", "info"]),
            standardWarning: standardStyles(dt, ["signal", "warning"]),
            standardError: standardStyles(dt, ["signal", "error"]),
            outlined: {},
            outlinedSuccess: outlinedStyles(dt, ["signal", "success"]),
            outlinedInfo: outlinedStyles(dt, ["signal", "info"]),
            outlinedWarning: outlinedStyles(dt, ["signal", "warning"]),
            outlinedError: outlinedStyles(dt, ["signal", "error"]),
            filled: {},
            filledSuccess: filledStyles(dt, ["signal", "success"]),
            filledInfo: filledStyles(dt, ["signal", "info"]),
            filledWarning: filledStyles(dt, ["signal", "warning"]),
            filledError: filledStyles(dt, ["signal", "error"]),
        },
    };
};
